import React from 'react';
import { always, equals, ifElse, Arity1Fn } from 'ramda';
import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { Link } from 'gatsby';

import { InternalPageData } from '../interfaces/internalPageData.types';
import { LanguageSlug } from '../enums/languageSlug.enum';
import { PageCategory } from '../enums/pageCategory.enum';

import { getBaseUrlByCategory, getLanguagePrefix } from './url.utils';

export const renderWhen = (
    pred: (b: true) => boolean,
    fn: Arity1Fn,
    otherwise: Arity1Fn = always(null)
  ): Arity1Fn => ifElse(pred, fn, otherwise);

export const renderWhenTrue = (
    fn: Arity1Fn
  ): Arity1Fn => renderWhen(equals(true), fn);

export const renderWhenTrueOr = (
    fn: Arity1Fn,
    otherwise: Arity1Fn
  ): Arity1Fn => renderWhen(equals(true), fn, otherwise);

export const styleWhenTrue = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pred: (b: any) => boolean,
    style: FlattenSimpleInterpolation,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  ) => (props: any): Arity1Fn => renderWhen(equals(true), always(style))(pred(props));

export const styleIfElse = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pred: (b: any) => boolean,
    styleIfTrue: FlattenSimpleInterpolation | string,
    styleIfFalse: FlattenSimpleInterpolation | string,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  ) => (props: any): Arity1Fn => renderWhen(equals(true), always(styleIfTrue), always(styleIfFalse))(pred(props));

export const renderExternalLink = (label: string | React.ReactNode, link: string) => {
  const ExternalLink = styled.a``;

  return (
    <ExternalLink
      target='_blank'
      rel='noopener noreferrer'
      href={link}
    >
      {label}
    </ExternalLink>
  )
};

export const renderInternalLink = (label: string | React.ReactNode, internalPage: InternalPageData, currentLanguage?: LanguageSlug) => {
  const projectUrl = (internalPage && internalPage.categories) ? getBaseUrlByCategory(internalPage.categories) : '';

  return (
    <Link
      to={`${projectUrl}/${getLanguagePrefix(currentLanguage)}${internalPage?.post_name}`}
    >
      {label}
    </Link>
  )
};
